import { TabPanel } from "@mui/lab";
import { SxProps, useTheme } from "@mui/material";
import { ReactNode } from "react";

type Props = {
  value: string
  children: ReactNode
  sx?: SxProps
};

export const Q3DTabPanel = (props: Props) => {
  const theme = useTheme();
  return (
    <TabPanel value={props.value} dir={theme.direction} sx={{...props.sx, padding: "0px"}}>
      {props.children}
    </TabPanel>
  );
};
